import { type FC } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

import { CheckmarkIcon, CloseIcon, DeleteIcon } from "~/components/Icon"
import InputField from "~/components/InputField"

type Props = {
	index: number
	text: string
	isCorrect: boolean
	onTextChange: (value: string) => void
	onIsCorrectChange: (value: boolean) => void
	onDelete: () => void
}
const QuizAnswer: FC<Props> = ({ index, text, isCorrect, onTextChange, onIsCorrectChange, onDelete }) => (
	<div className="border-component-border flex items-center gap-2 rounded-lg border bg-white p-2 shadow-sm">
		<span className="bg-primary/10 text-primary flex size-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold">
			{index + 1}
		</span>
		<div className="min-w-0 flex-1">
			<InputField value={text} onChange={onTextChange} placeholder="Enter answer option..." compact />
		</div>
		<button
			type="button"
			onClick={() => onIsCorrectChange(!isCorrect)}
			aria-label={`Mark answer ${index + 1} as ${isCorrect ? "incorrect" : "correct"}`}
			aria-pressed={isCorrect}
			title={isCorrect ? "Mark as incorrect" : "Mark as correct"}
			className={cn(
				"flex size-9 shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-lg border px-0 text-xs font-semibold transition-colors sm:w-24.5 sm:px-2",
				isCorrect
					? "border-success/20 bg-success/10 text-success hover:bg-success/15"
					: "border-danger/20 bg-danger/10 text-danger hover:bg-danger/15",
			)}
		>
			{isCorrect ? <CheckmarkIcon className="size-4" /> : <CloseIcon className="size-4" />}
			<span className="hidden sm:inline">{isCorrect ? "Correct" : "Incorrect"}</span>
		</button>
		<button
			type="button"
			onClick={onDelete}
			aria-label={`Delete answer ${index + 1}`}
			title="Delete answer"
			className="border-danger/20 text-danger hover:bg-danger/10 flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-lg border bg-white transition-colors"
		>
			<DeleteIcon className="size-4" />
		</button>
	</div>
)

export default QuizAnswer
